import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { NavParams } from 'ionic-angular';

import { Devices, Tools } from '../../providers';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  renders:Array<{}>
  features:Array<{}>

  constructor(
    public navCtrl: NavController,
    private navParams: NavParams,
    public tools: Tools
  ) {
    this.renders = navParams.get('renders');
    this.features = [
      {title:'Display',field:'feature1'},
      {title:'Câmera / Frontal',field:'feature2'},
      {title:'Processador',field:'feature3'},
      {title:'Memória RAM',field:'feature4'},
      {title:'Memória Interna',field:'feature5'},
      {title:'Bateria',field:'feature6'},
      {title:'Sistema (Versão)',field:'feature7'}
    ]
  }

  listarRenders() {
    this.navCtrl.pop();
  }

  rev(){
    this.tools.showAlert('toast','Versão 3.0.3');
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts